import ValuerAmendFieldListHandler from "./ValuerAmendFieldListHandler";
import {useEffect, useState} from "react";
import valuer_api from "../../api/valuer";


const ValuerAmendCustomAdditionsContainer = (props) => {
    const summaryId = props.summaryId
    const section = props.sectionName
    const identifier = props.identifier

    const fieldList = props.fieldList

    const buttonText = props.buttonText
    const fieldTitles = props.fieldTitles

    const [values, setValues] = useState({})

    // Functions
    const UpdateParentValue = props.UpdateParentValue
    const AddToQueue = props.AddToQueue
    const RemoveFromQueue = props.RemoveFromQueue
    const AddToErroredSaves = props.AddToErroredSaves

    const setErrorMessage = props.setErrorMessage
    const setErrorTitle = props.setErrorTitle

    useEffect(() => {
        const newValues = props.values && typeof props.values === 'object' ? { ...props.values } : {}
        setValues(newValues)
    }, [props.values])

    const AddNewRow = () => {
        let updateTime = Date.now()
        AddToQueue(section, identifier, updateTime)
        let obj = Object.assign({}, values)
        let keys = []
        Object.keys(obj).forEach(x => keys.push(parseInt(x)))
        let row_id = 1
        if (keys.length) {
            row_id = Math.max(...keys) + 1
        }
        obj[row_id] = {}
        for(const identifier of fieldList.map(x => x.identifier)) {
            obj[row_id][identifier] = null
        }

        setValues(() => {return obj})
    }

    const UpdateFurtherParent = (_ident, _value, _row) => {
        if (!_ident || !_row) return
        setValues(v => {
            let v_copy = Object.assign({}, v)
            if (_row && v_copy[_row]) v_copy[_row][_ident] = _value
            return v_copy
        })
    }

    return (
        <div className="valuer-amend-custom-addition-container">
            <div className="valuer-amend-custom-addition-titles-container">
                {fieldTitles && fieldList && fieldList.map((field, idx) => {
                    return (
                        <div className="valuer-amend-column-title-container" style={{width: field.width, minWidth: field.minWidth}}>
                            {fieldTitles[idx] && fieldTitles[idx]}
                        </div>
                    )
                })}
            </div>
            {values && Object.keys(values).map((row_id, idx) => {
                return (
                    <div className="valuer-amend-column-container nowrap" key={idx}>
                        <ValuerAmendFieldListHandler fieldList={fieldList}
                                                     rowId={row_id}
                                                     values={values}
                                                     sectionName={identifier}
                                                     summaryId={summaryId}
                                                     setErrorMessage={setErrorMessage}
                                                     setErrorTitle={setErrorTitle}
                                                     UpdateParentValue={UpdateFurtherParent}
                                                     AddToQueue={AddToQueue.bind(this)}
                                                     RemoveFromQueue={RemoveFromQueue.bind(this)}
                                                     AddToErroredSaves={AddToErroredSaves.bind(this)}
                                                     value={values}/>
                    </div>
                )
            })}
            <div className="valuer-amend-column-add-row-button link" onClick={() => AddNewRow()}>
                + {buttonText}
            </div>
        </div>
    )
}

export default ValuerAmendCustomAdditionsContainer;